import {Helmet} from 'react-helmet'
import {useTranslation} from '@/translations/i18n.tsx'
import {envVars} from '@/envVars.ts'
import {Container} from '@components/ui/container'
import {PersonalInformation} from '@features/settings/components/personal-information'
import {Separator} from '@components/ui/separator'
import {Availability} from '@features/settings/components/availability'
import {AccountSecurity} from '@features/settings/components/account-security'
import {Notifications} from '@features/settings/components/notifications'
import {Calendar} from '@features/settings/components/calendar'
import {LinkAirbnbAccountSection} from '@features/settings/components/link-airbnb-account-section'
import {ProgramsSettings} from '@features/floor-plan/components/programs-settings'
import {useFloorPlanOptin} from '@features/floor-plan/queries/useFloorPlanOptin'

export const Settings = () => {
    const {t} = useTranslation()
    const {isVisible} = useFloorPlanOptin()
    return (
        <div className="h-full">
            <Container className="flex flex-col gap-6 py-4 md:gap-8 md:pt-16 md:pb-12">
                <Helmet title={t('titles:settings')} />

                <PersonalInformation />

                <Separator orientation="horizontal" />

                <LinkAirbnbAccountSection />

                <Separator orientation="horizontal" />

                <Availability />

                {envVars.VITE_IS_FLOOR_PLAN_ENABLED && isVisible && (
                    <>
                        <Separator orientation="horizontal" />

                        <ProgramsSettings />
                    </>
                )}

                <Separator orientation="horizontal" />

                <Notifications />

                <Separator orientation="horizontal" />

                <Calendar />

                <Separator orientation="horizontal" />

                <AccountSecurity />
            </Container>
        </div>
    )
}
